<div class="flex-col items-stretch space-y-4">
	<span class="text-lg underline-none">
		{{
			'presentation.app.page.profile.coachee.informations.recentActivity.header'
				| translate
		}}
	</span>
	<div class="flex-auto flex-col">
		<ng-scrollbar
			class="absolute h-full w-full"
			track="vertical"
			visibility="hover"
		>
			<div
				*ngFor="let task of controller.pendingTasks$ | async; let last = last"
				class="mb-4"
			>
				<p-card>
					<div class="flex-row space-x-2">
						<i
							class="{{
								task.typeCssIconClass
							}} space-x-3 p-color-primary font-semibold"
						></i>
						<span
							[innerHTML]="
								task.description
									| translate
										: {
												contact: task.contact$ | async,
												jobOffer: task.jobOffer$ | async,
												participantsName:
													$any(task.participants$ | async)
													| usersName: (controller.coacheeId$ | async),
												modulesName: task.modulesName$ | async,
												date: (task.dueDate | userDate: 'LT' | async)
										  }
							"
						></span>
						<ng-container
							*ngIf="$any(task.modulesData$ | async) | nullIfEmpty; let modulesData"
						>
							<span *ngFor="let moduleData of modulesData; let last = last">
								<a
									[routerLink]="[
										'/activity',
										moduleData.id,
										'user',
										controller.coacheeId$ | async
									]"
									class="font-bold"
								>
									{{ moduleData.name }}
								</a>
								<ng-container *ngIf="!last">,&nbsp;</ng-container>
							</span>
						</ng-container>
					</div>
				</p-card>
			</div>
		</ng-scrollbar>
	</div>
</div>
